import React from 'react';
import {CircularProgress, Stack} from "@mui/joy";

// components
import CommonInfoTab from "../Common/CommonInfoTab";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";

// icons
import InfoIcon from "@mui/icons-material/Info";


class ApplicantTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            updatePermission: null,
            applicant: this.props.applicant,
        }
    }

    async componentDidMount(){
        await this.retrieveUpdatePermission();
    }

    async retrieveUpdatePermission() {
        let p = await retrievePermission(
            'ApplicantViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        this.setState(
            {
                updatePermission: p
            }
        );
    }

    render() {
        if (this.state.updatePermission === null) {
            return (<CircularProgress/>)
        }
        let infoFields = [
            ['phone', 'Телефон'],
            ['email', 'Электронная почта'],
            ['date_applied', 'Дата подачи заявки'],
            ['archived', 'В архиве'],
            ['motivation_letter', 'Мотивационное письмо', true],
            ['school', 'ВУЗ'],
            ['specialization', 'Специальность'],
            ['course_human', 'Курс', false, 'course'],
            ['school_end_year', 'Год окончания вуза'],
        ].map((f) => ({
            title: f[1],
            value: this.state.applicant[f[0]],
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            html: f[2]?f[1]:false,
            edit: {
                permission: this.state.updatePermission,
                fields: [f[3]?f[3]:f[0], ],
                baseUrl: 'applicant',
                obj: this.props.applicant
            }
        }))
        return(
            <Stack
                spacing={2}
            >
                <CommonInfoTab
                    callBack={this.props.callBack}
                    groups={
                        [
                            {
                                title: 'Общая информация',
                                icon: <InfoIcon/>,
                                fields: infoFields
                            }
                        ]
                    }
                />
            </Stack>
        )
    }
}

export default ApplicantTab